var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOval42CError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  d: "M15 30a5 5 0 0 1 5-5h20a5 5 0 0 1 0 10H20a5 5 0 0 1-5-5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M27 16.5a2.5 2.5 0 0 1-2.5 2.5h-11a2.5 2.5 0 0 1-2.5-2.5v-10A2.5 2.5 0 0 1 13.5 4h11A2.5 2.5 0 0 1 27 6.5v10Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M27 14V6.5A2.5 2.5 0 0 0 24.5 4h-11A2.5 2.5 0 0 0 11 6.5V14"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M33 43.5a2.5 2.5 0 0 1 2.5-2.5h11a2.5 2.5 0 0 1 2.5 2.5v10a2.5 2.5 0 0 1-2.5 2.5h-11a2.5 2.5 0 0 1-2.5-2.5v-10Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M33 46v7.5a2.5 2.5 0 0 0 2.5 2.5h11a2.5 2.5 0 0 0 2.5-2.5V46"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M49 16.5a2.5 2.5 0 0 1-2.5 2.5h-11a2.5 2.5 0 0 1-2.5-2.5v-10A2.5 2.5 0 0 1 35.5 4h11A2.5 2.5 0 0 1 49 6.5v10Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M49 14V6.5A2.5 2.5 0 0 0 46.5 4h-11A2.5 2.5 0 0 0 33 6.5V14"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M11 43.5a2.5 2.5 0 0 1 2.5-2.5h11a2.5 2.5 0 0 1 2.5 2.5v10a2.5 2.5 0 0 1-2.5 2.5h-11a2.5 2.5 0 0 1-2.5-2.5v-10Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M11 46v7.5a2.5 2.5 0 0 0 2.5 2.5h11a2.5 2.5 0 0 0 2.5-2.5V46"
})));
SvgOval42CError.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgOval42CError);
export default ForwardRef;